import React from "react";

const Footer = () => (
  <footer className="bg-[#111827] text-white py-10 text-center grid sm:grid-rows-3 md:grid-rows-none md:grid-cols-3 gap-4 justify-center items-center">
    <img
      src="/leda-group/logo.png"
      alt="LEDA Logo"
      className="h-auto w-48 m-auto"
    />
    <nav className="space-x-6 text-lg mb-6">
      <a
        href={`${process.env.REACT_APP_SITE_URL}leda-group/`}
        className="hover:underline"
      >
        Home
      </a>
      <a
        href={`${process.env.REACT_APP_SITE_URL}682afc064e30fe1a6c969ab3/career?page=leda`}
        className="hover:underline"
      >
        Careers
      </a>
      <a
        href={`${process.env.REACT_APP_SITE_URL}leda-group/about`}
        className="hover:underline"
      >
        About LEDA
      </a>
    </nav>
    <div className="space-x-4">
      <a
        href="tel:01865965122"
        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded"
      >
        Call us
      </a>
      <a
        href="mailto:info@leda-group.co.uk"
        className="bg-white text-black py-2 px-4 rounded"
      >
        Message
      </a>
    </div>
  </footer>
);

export default Footer;
